export default __webpack_public_path__ + "static/media/favorite-star-filled.e994abf2.svg";